import { Injectable } from '@angular/core';
import { Confirmation, ConfirmationService } from 'primeng/api';

/**
 * PrimeNG's ConfirmDialog keeps every option from the previous confirm()
 * unless the next call sends that option again. Defaults here match the
 * shared dialog in crm-layout (header "Confirmation", warning icon) and
 * PrimeNG's Yes / No labels. Options passed by the caller still win.
 */
const CONFIRM_DIALOG_DEFAULTS: Confirmation = {
  header: 'Confirmation',
  icon: 'pi pi-exclamation-triangle',
  acceptLabel: 'Yes',
  rejectLabel: 'No',
  acceptVisible: true,
  rejectVisible: true,
};

@Injectable()
export class CrmConfirmationService extends ConfirmationService {
  override confirm(confirmation: Confirmation): this {
    return super.confirm({
      ...CONFIRM_DIALOG_DEFAULTS,
      ...confirmation,
    });
  }
}
